document.addEventListener("DOMContentLoaded", () => {
  const section = document.querySelector('[data-section-type="video-thumbnail-slider"]');
  if (!section) return;

  const videos = section.querySelectorAll(".video");
  const thumbs = section.querySelectorAll(".navigation li");
  const overlays = section.querySelectorAll(".video-overlay");

  const styles = getComputedStyle(section);
  const activeBorder = styles.getPropertyValue('--border-active').trim();
  const inactiveBorder = styles.getPropertyValue('--border-inactive').trim();

  let overlayTimers = [];

  const clearOverlaysAndTimers = () => {
    overlayTimers.forEach(timer => clearTimeout(timer));
    overlayTimers = [];

    overlays.forEach(o => {
      o.classList.remove("visible");
      o.style.pointerEvents = "none";
    });
  };

  /* ==============================
     ACTIVATE THUMBNAIL & VIDEO
  ============================== */
  const activateThumb = (thumb) => {
    if (!thumb) return;

    const button = thumb.querySelector(".navigation-button");
    const newVideoSrc = button.dataset.videoSrc;

    // Reset thumbnails
    thumbs.forEach(t => {
      t.classList.remove("active");
      t.style.borderColor = inactiveBorder;
      t.style.opacity = "0.7";
    });

    // Activate selected thumb
    thumb.classList.add("active");
    thumb.style.borderColor = activeBorder;
    thumb.style.opacity = "1";

    clearOverlaysAndTimers();

    let foundVideo = false;

    videos.forEach((video, index) => {
      const source = video.querySelector("source");

      if (source && source.src === newVideoSrc) {
        foundVideo = true;

        video.classList.add("loaded");
        video.currentTime = 0;

        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch(() => {
            video.muted = true;
            video.play();
          });
        }

        const overlay = overlays[index];
        if (overlay) {
          const timer = setTimeout(() => {
            if (video.classList.contains("loaded")) {
              overlay.classList.add("visible");
              overlay.style.pointerEvents = "auto";
            }
          }, 3000);
          overlayTimers.push(timer);
        }
      } else {
        video.classList.remove("loaded");
        video.pause();
      }
    });

    // Fallback safety
    if (!foundVideo && videos.length) {
      const video = videos[0];
      const source = video.querySelector("source");

      source.src = newVideoSrc;
      video.load();

      video.addEventListener("loadeddata", function handler() {
        video.classList.add("loaded");
        video.play().catch(() => {
          video.muted = true;
          video.play();
        });
        this.removeEventListener("loadeddata", handler);
      });
    }
  };

  /* ==============================
     AUTO PLAY NEXT VIDEO
  ============================== */
  const playNextVideo = (currentIndex) => {
    const nextIndex = (currentIndex + 1) % thumbs.length;
    activateThumb(thumbs[nextIndex]);
  };

  videos.forEach((video, index) => {
    video.loop = false; // REQUIRED for ended event

    video.addEventListener("ended", () => {
      if (video.classList.contains("loaded")) {
        playNextVideo(index);
      }
    });
  });

  /* ==============================
     THUMBNAIL CLICK / KEYBOARD
  ============================== */
  const thumbButtons = section.querySelectorAll(".navigation .navigation-button");

  thumbButtons.forEach(button => {
    button.addEventListener("click", () => {
      activateThumb(button.closest("li"));
    });

    button.addEventListener("keydown", e => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        activateThumb(button.closest("li"));
      }
    });
  });

  /* ==============================
     INTERSECTION OBSERVER
  ============================== */
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const video = entry.target;
      if (!entry.isIntersecting) {
        video.pause();
      } else if (video.classList.contains("loaded")) {
        video.play().catch(() => {
          video.muted = true;
          video.play();
        });
      }
    });
  }, { threshold: 0.25 });

  videos.forEach(video => observer.observe(video));

  /* ==============================
     INIT FIRST VIDEO
  ============================== */
  const firstActiveThumb = section.querySelector(".navigation li.active");
  if (firstActiveThumb) {
    activateThumb(firstActiveThumb);
  }

  /* ==============================
     MARK SECTION READY (CLS FIX)
  ============================== */
  section.classList.add("is-ready")
});